import React from 'react';

const MalaysiaIndonesiaAIGov = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Malaysia and Indonesia are the two largest economies in Southeast Asia by population,
      and both moved significantly on AI governance in 2024-2025. Malaysia created new
      dedicated institutions and a formal AI ethics framework. Indonesia combined new
      data protection legislation with AI-specific presidential regulations. Neither is
      the EU AI Act - but both are real, enforced governance frameworks that companies
      operating in the region need to understand.
    </p>

    <h2>Malaysia: NAIO and the AIGE framework</h2>
    <p>
      Malaysia's National AI Office (NAIO), established under the Ministry of Digital in
      2024, is the central coordination body for AI policy. It works alongside the AI
      Governance and Ethics (AIGE) framework, which provides practical guidance for
      public sector AI deployments.
    </p>
    <p>
      The AIGE framework is built around five principles:
    </p>
    <ul>
      <li><strong>Transparency:</strong> AI systems must be explainable to users and auditors</li>
      <li><strong>Fairness:</strong> Prevent discriminatory outcomes in automated decisions</li>
      <li><strong>Safety:</strong> Risk assessment required before deployment in high-stakes contexts</li>
      <li><strong>Accountability:</strong> Clear ownership for AI system outcomes</li>
      <li><strong>Privacy:</strong> Compliance with Malaysia's Personal Data Protection Act 2010</li>
    </ul>
    <p>
      Malaysia has also been a notable investor in AI infrastructure - the government
      committed RM25 billion to data centres and AI facilities under Madani Economy
      initiatives, with significant hyperscaler investment from Microsoft, Google, and AWS.
    </p>

    <h2>Malaysia's AI talent pipeline</h2>
    <p>
      The NAIO is coordinating AI curriculum integration into Malaysian universities and
      vocational colleges, with a target of 50,000 AI-ready graduates per year by 2027.
      This is an ambitious target - but reflects recognition that governance frameworks
      are only as good as the people who implement them.
    </p>

    <h2>Indonesia: UU PDP and AI regulation</h2>
    <p>
      Indonesia's Personal Data Protection Law (UU PDP) took effect in 2024 after a
      four-year legislative journey. Key provisions relevant to AI:
    </p>
    <ul>
      <li>Automated decision-making that significantly affects individuals requires human review capability</li>
      <li>Data subjects have the right to explanation of algorithmic decisions</li>
      <li>Sensitive personal data (health, financial, biometric) has strict processing requirements</li>
    </ul>
    <p>
      Presidential Regulation 68/2024 built on UU PDP with AI-specific guidance, particularly
      for government AI deployments. Public agencies must document AI systems, conduct impact
      assessments for high-risk applications, and maintain audit trails.
    </p>

    <h2>Practical implications for businesses</h2>
    <p>
      For companies operating across Malaysia and Indonesia:
    </p>
    <ul>
      <li>Automated customer-facing decisions (credit, insurance, hiring) face documentation requirements in both markets</li>
      <li>Data localisation requirements in Indonesia affect where AI training data and model outputs can be stored</li>
      <li>Malaysian government procurement increasingly requires AIGE framework compliance for AI components</li>
    </ul>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Malaysia and Indonesia are building AI governance infrastructure, not waiting for
        global standards to emerge. For businesses, that means compliance work now - but also
        the opportunity to engage with governance frameworks that are still being shaped. Companies
        that participate in industry consultations in both markets today will have a better
        understanding of where requirements are heading than those who wait for final regulations.
      </p>
    </div>
  </article>
);

export default MalaysiaIndonesiaAIGov;
